import { OPEN_PROMO_MODAL, CLOSE_PROMO_MODAL } from './types';

export const openModal = () => ({ type: OPEN_PROMO_MODAL });
export const closeModal = () => ({ type: CLOSE_PROMO_MODAL });
